import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { Location } from '@angular/common';

@Injectable()
export class PermisoGuard implements CanActivate {
    public location: Location;

    constructor(
        protected localStorage: AsyncLocalStorage,
        private router: Router,
    ){
        //
    } 

    canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        //let path = this.location.path();
        
        let path = state.url;

        return new Promise((resolve, reject) => {
            this.localStorage.getItem('menuItems').subscribe(
                res => {
                    let menuItems = res;
                    menuItems.forEach(item => {
                        if( item.path === path ){
                            resolve(true);
                            return;
                        }
                        
                        if( item.children.length ){
                            item.children.forEach(child => {
                                if( child.path === path ){
                                    resolve(true);
                                    return;
                                }
                            });
                        }
    
                        if( item.transacciones.length ){
                            item.transacciones.forEach(child => {
                                if( child.path === path ){
                                    resolve(true);
                                    return;
                                }
                            });
                        }
    
                        if( item.consultas.length ){
                            item.consultas.forEach(child => {
                                if( child.path === path ){
                                    resolve(true);
                                    return;
                                }
                            });
                        }
                    });
                },
                err => {
                    reject(false);
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/guards/permiso.guard.ts